import React from 'react';
import clsx from 'clsx';
import {
  ExclamationTriangleIcon,
  InformationCircleIcon,
  CheckCircleIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';

const variants = {
  info: {
    icon: InformationCircleIcon,
    bgVar: 'var(--color-status-info)',
    textVar: 'var(--color-status-info-text)',
  },
  success: {
    icon: CheckCircleIcon,
    bgVar: 'var(--color-status-success)',
    textVar: 'var(--color-status-success-text)',
  },
  warning: {
    icon: ExclamationTriangleIcon,
    bgVar: 'var(--color-status-warning)',
    textVar: 'var(--color-status-warning-text)',
  },
  error: {
    icon: XCircleIcon,
    bgVar: 'var(--color-status-error)',
    textVar: 'var(--color-status-error-text)',
  },
};

export function Alert({ children, variant = 'info', className, onClose }) {
  const v = variants[variant];
  const Icon = v.icon;

  return (
    <div
      className={clsx('flex items-start gap-3 border p-4', className)}
      role="alert"
      style={{
        backgroundColor: `color-mix(in srgb, ${v.bgVar} 10%, white)`,
        borderColor: `color-mix(in srgb, ${v.bgVar} 30%, white)`,
        borderRadius: 'var(--r-base)',
      }}
    >
      <Icon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: v.bgVar }} />
      <div className="flex-1 text-sm" style={{ color: v.textVar }}>{children}</div>
      {onClose && (
        <button onClick={onClose} style={{ color: 'var(--color-text-secondary)' }}>
          <XCircleIcon className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
